export enum REQUESTS_FORM_ID {
  General = 'general',
  UpdatePersonalDetails = 'update-personal-details',
  updateBankDetails = 'update-bank-details',
  expenseClaim = 'expense-claim',
}

export const FORM_STEPS_AMOUNT: { [key: string]: number } = {
  general: 0,
  'update-personal-details': 1,
  'update-bank-details': 1,
  'expense-claim': 1,
};
